type PhoneType = 'mobile' | 'fixed'

export function formatPhoneNumber(
  phone: number | string | null | undefined,
  type: PhoneType,
): string {
  if (phone === null || phone === undefined) {
    return ''
  }

  const cleaned = phone.toString().replace(/\D/g, '')

  if (!cleaned || cleaned.length === 0) {
    return ''
  }

  try {
    if (type === 'mobile') {
      if (cleaned.length < 9 || !/^7/.test(cleaned)) {
        return phone.toString()
      }

      const usableDigits = cleaned.padEnd(9, '0')
      return `+213${usableDigits[0]} ${usableDigits.slice(1, 3)} ${usableDigits.slice(3, 5)} ${usableDigits.slice(5, 7)} ${usableDigits.slice(7)}`
    }

    if (type === 'fixed') {
      if (cleaned.length < 8 || !/^2/.test(cleaned)) {
        return phone.toString()
      }

      const usableDigits = cleaned.padEnd(8, '0')
      return `0${usableDigits.slice(0, 2)} ${usableDigits.slice(2, 4)} ${usableDigits.slice(4, 6)} ${usableDigits.slice(6)}`
    }

    return phone.toString()
  } catch (error) {
    return phone ? phone.toString() : ''
  }
}
